/** The subset of a PointerEvent the engine needs. Lets replay and tests drive the real input path. */
export interface RawSample {
  clientX: number;
  clientY: number;
  pressure: number;
  tiltX: number;
  tiltY: number;
  /** DOMHighResTimeStamp, same clock as performance.now(). */
  timeStamp: number;
}

export interface PointerMeta {
  pointerId: number;
  pointerType: string;
  button: number;
  buttons: number;
  width: number;
  height: number;
}

export function toSample(e: PointerEvent): RawSample {
  return { clientX: e.clientX, clientY: e.clientY, pressure: e.pressure, tiltX: e.tiltX, tiltY: e.tiltY, timeStamp: e.timeStamp };
}

/** Coalesced samples for an event; falls back to the event itself (e.g. pointerdown/up). */
export function coalesced(e: PointerEvent): RawSample[] {
  const list = typeof e.getCoalescedEvents === 'function' ? e.getCoalescedEvents() : [];
  return list.length > 0 ? list.map(toSample) : [toSample(e)];
}

export function predicted(e: PointerEvent): RawSample[] {
  return typeof e.getPredictedEvents === 'function' ? e.getPredictedEvents().map(toSample) : [];
}

export function metaOf(e: PointerEvent): PointerMeta {
  return { pointerId: e.pointerId, pointerType: e.pointerType, button: e.button, buttons: e.buttons, width: e.width, height: e.height };
}
